import Dexie from 'dexie';

// Local database on the device (IndexedDB). Two jobs:
//   outbox - every write, queued until the server has confirmed it
//   cache  - the last good copy of what screens read, so they open offline
// Modules add their own tables in a new version() block; never change an old one.
export function openDb(name = 'nano-utilities') {
  const db = new Dexie(name);
  db.version(1).stores({
    outbox: '&id, status, createdAt',
    cache: '&key',
  });
  // Photos taken on a job, kept until uploaded.
  db.version(2).stores({
    outbox: '&id, status, createdAt',
    cache: '&key',
    photos: '&id, bookingId, takenAt',
  });
  // Photos and screenshots on helpdesk tickets, kept until uploaded.
  db.version(3).stores({
    outbox: '&id, status, createdAt',
    cache: '&key',
    photos: '&id, bookingId, takenAt',
    ticketFiles: '&id, ticketId, addedAt',
  });
  return db;
}

export const db = openDb();

export async function cacheGet(key) {
  return (await db.cache.get(key))?.value;
}

export async function cachePut(key, value) {
  await db.cache.put({ key, value, savedAt: new Date().toISOString() });
}
